module.exports = __webpack_public_path__ + "img/cover-bg-2.f2944fdb.png";